//React
import React from 'react';
import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';

//Icon
import CloseIcon from '@material-ui/icons/Close';


class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checkBool: false,
      checkName: null,
      checkComment: null,
      confirm: false,
      datetime: null,
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.open !== prevProps.open && this.props.open === true) {
      this.props.coupleRequestCheck(this.props.pic, (data) => {
        this.setState({
          checkBool: data.bool,
          checkName: data.name,
          checkComment: data.comment,
          datetime: (new Date()),
        })
      });
    }
  }

  _submit(coupleId) {
    this.props.coupleReceptionOk(coupleId, (data) => {
      if (data.bool) {
        this.props.history.push('/coupleReceptionEnd/');
      }
    });
    this.props.close();
  }

	render() {
		return (
			<Dialog
        open={this.props.open}
        maxWidth='xs'
      >
      {
        (this.state.datetime) && (
          <div>
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
                justifyContent:'space-between',
              }}
            >
              <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                カップリング
              </div>
              <IconButton
                onClick={ () => this.props.close() }
              >
                <CloseIcon/>
              </IconButton>
            </div>

            <div style={{padding:'10px'}}>
              {
                (this.state.checkBool) ? (
                  <div>
                    <div style={{margin:'10px'}}>
                      <div>{this.state.checkName} さんとカップリングしますか？</div>
                    </div>
                    <div style={{margin:'10px'}}>
                      真剣な交際に向けてカップリングする事に同意いただけますか？
                      <Checkbox
                        checked={this.state.confirm}
                        onChange={ () => this.setState({confirm: (this.state.confirm) ? false: true })}
                        color="primary"
                      />
                    </div>
                    <div align='center' style={{padding:'10px'}}>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{minWidth:'200px'}}
                        onClick={ () => this._submit(this.props.coupleId) }
                        disabled={ this.state.confirm ? false: true }
                      >
                        <span style={{fontSize:'1.2em'}}>カップリングする</span>
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div style={{color:'red'}}>{this.state.checkComment}</div>
                )
              }
            </div>
          </div>
        )
      }
			</Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...coupleAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
